module.exports = __webpack_public_path__ + "img/t1-i0.4192fb95.png";